package mapsearch.globalsearch

import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.transformLatest

// --- reusable splitter for UI vs analytics search flows -------------------
fun <T> Flow<T>.splitFlowForAnalytics(
    uiDebounce: Long = 300L,
    analyticsIdle: Long = 1500L,
    minLen: Int = 3,
    toQuery: (T) -> String,
    toTags: (T) -> List<String>,
): Pair<Flow<T>, Flow<Pair<String, List<String>>>> {

    // Fast-debounced flow for the UI
    val ui = this
        .debounce(uiDebounce)
        .distinctUntilChanged()

    /* Idle-based flow for analytics
       – waits for `analyticsIdle` ms of *silence*,
       – then emits exactly once (the latest query),
       – so you always get the *final* search string. */
    val analytics = this.transformLatest { ctx ->
        delay(analyticsIdle)
        val query = toQuery(ctx).trim()
        if (query.length >= minLen) emit(query to toTags(ctx))
    }.distinctUntilChanged()

    return ui to analytics
}
